<template>
  <div class="content-wrapper bg-white shadow-sm">
    <RouterLink to="/" class="btn btn-outline-secondary mb-4"><i class="fa-solid fa-arrow-left"></i> <i class="fa-solid fa-house"></i></RouterLink>

    <h1 class="mb-4">What crops are in what crop group?</h1>
    <p>
Crop group load intensities, as shown in the Nutrient Navigator, are calculated from loads associated with the cultivation of the following underlying crops. Listed with each crop is its FAOSTAT crop code. Nes is a FAOSTAT designation for crops that are not elsewhere specified. For more information on crop names and grouping, see <a href="https://openknowledge.fao.org/server/api/core/bitstreams/8f3f2ac4-88ea-47d0-8923-11a5eafc5d9d/content" target="_BLANK">FAO’s data framework</a>.
    </p>
  </div>

  <div ref="masonryContainer" class="crop-ctn mt-5">
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Cereal</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Barley</td><td>44</td></tr>
<tr><td>Buckwheat</td><td>89</td></tr>
<tr><td>Cereals, nes</td><td>108</td></tr>
<tr><td>Maize</td><td>56</td></tr>
<tr><td>Millet</td><td>79</td></tr>
<tr><td>Mixed grain</td><td>103</td></tr>
<tr><td>Oats</td><td>75</td></tr>
<tr><td>Rice, paddy</td><td>27</td></tr>
<tr><td>Rye</td><td>71</td></tr>
<tr><td>Sorghum</td><td>83</td></tr>
<tr><td>Triticale</td><td>97</td></tr>
<tr><td>Wheat</td><td>15</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Roots & Tubers</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Cassava</td><td>125</td></tr>
<tr><td>Potatoes</td><td>116</td></tr>
<tr><td>Roots and Tubers, nes</td><td>149</td></tr>
<tr><td>Sweet potatoes</td><td>122</td></tr>
<tr><td>Taro (cocoyam)</td><td>136</td></tr>
<tr><td>Yams</td><td>137</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Sugar Crops</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Sugar cane</td><td>156</td></tr>
<tr><td>Sugar beet</td><td>157</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Pulses</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Beans, dry</td><td>176</td></tr>
<tr><td>Broad beans, horse beans, dry</td><td>181</td></tr>
<tr><td>Chick peas</td><td>191</td></tr>
<tr><td>Cow peas, dry</td><td>195</td></tr>
<tr><td>Lentils</td><td>201</td></tr>
<tr><td>Lupins</td><td>210</td></tr>
<tr><td>Peas, dry</td><td>187</td></tr>
<tr><td>Pigeon peas</td><td>197</td></tr>
<tr><td>Pulses, nes</td><td>211</td></tr>
<tr><td>Vetches</td><td>205</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Nuts</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Almonds, with shell</td><td>221</td></tr>
<tr><td>Cashew nuts, with shell</td><td>217</td></tr>
<tr><td>Chestnuts</td><td>220</td></tr>
<tr><td>Hazelnuts, with shell</td><td>225</td></tr>
<tr><td>Nuts, nes</td><td>234</td></tr>
<tr><td>Pistachios</td><td>223</td></tr>
<tr><td>Walnuts, with shell</td><td>222</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Oil Crops</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Castor oil seed</td><td>265</td></tr>
<tr><td>Coconuts</td><td>249</td></tr>
<tr><td>Groundnuts, with shell</td><td>242</td></tr>
<tr><td>Linseed</td><td>333</td></tr>
<tr><td>Melonseed</td><td>299</td></tr>
<tr><td>Mustard seed</td><td>292</td></tr>
<tr><td>Oil palm fruit</td><td>254</td></tr>
<tr><td>Oilseeds, Nes</td><td>339</td></tr>
<tr><td>Olives</td><td>260</td></tr>
<tr><td>Rapeseed</td><td>270</td></tr>
<tr><td>Safflower seed</td><td>280</td></tr>
<tr><td>Seed cotton</td><td>328</td></tr>
<tr><td>Sesame seed</td><td>289</td></tr>
<tr><td>Soybeans</td><td>236</td></tr>
<tr><td>Sunflower seed</td><td>267</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Vegetables</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Artichokes</td><td>366</td></tr>
<tr><td>Asparagus</td><td>367</td></tr>
<tr><td>Beans, green</td><td>414</td></tr>
<tr><td>Cabbages and other brassicas</td><td>358</td></tr>
<tr><td>Carrots and turnips</td><td>426</td></tr>
<tr><td>Cauliflowers and broccoli</td><td>393</td></tr>
<tr><td>Chillies and peppers, green</td><td>401</td></tr>
<tr><td>Cucumbers and gherkins</td><td>397</td></tr>
<tr><td>Eggplants (aubergines)</td><td>399</td></tr>
<tr><td>Garlic</td><td>406</td></tr>
<tr><td>Lettuce and chicory</td><td>372</td></tr>
<tr><td>Maize, green</td><td>446</td></tr>
<tr><td>Okra</td><td>430</td></tr>
<tr><td>Onions (inc. shallots), green</td><td>402</td></tr>
<tr><td>Onions, dry</td><td>403</td></tr>
<tr><td>Peas, green</td><td>417</td></tr>
<tr><td>Pumpkins, squash and gourds</td><td>394</td></tr>
<tr><td>Spinach</td><td>373</td></tr>
<tr><td>String beans</td><td>423</td></tr>
<tr><td>Tomatoes</td><td>388</td></tr>
<tr><td>Vegetables fresh nes</td><td>463</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Fruit</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Apples</td><td>515</td></tr>
<tr><td>Apricots</td><td>526</td></tr>
<tr><td>Avocados</td><td>572</td></tr>
<tr><td>Bananas</td><td>486</td></tr>
<tr><td>Berries Nes</td><td>558</td></tr>
<tr><td>Blueberries</td><td>552</td></tr>
<tr><td>Cherries</td><td>531</td></tr>
<tr><td>Citrus fruit, nes</td><td>512</td></tr>
<tr><td>Cranberries</td><td>554</td></tr>
<tr><td>Currants</td><td>550</td></tr>
<tr><td>Dates</td><td>577</td></tr>
<tr><td>Figs</td><td>569</td></tr>
<tr><td>Fruit Fresh Nes</td><td>619</td></tr>
<tr><td>Fruit, tropical fresh nes</td><td>603</td></tr>
<tr><td>Gooseberries</td><td>549</td></tr>
<tr><td>Grapefruit (inc. pomelos)</td><td>507</td></tr>
<tr><td>Grapes</td><td>560</td></tr>
<tr><td>Kiwi fruit</td><td>592</td></tr>
<tr><td>Lemons and limes</td><td>497</td></tr>
<tr><td>Mangoes, mangosteens, guavas</td><td>571</td></tr>
<tr><td>Oranges</td><td>490</td></tr>
<tr><td>Papayas</td><td>600</td></tr>
<tr><td>Peaches and nectarines</td><td>534</td></tr>
<tr><td>Pears</td><td>521</td></tr>
<tr><td>Pineapples</td><td>574</td></tr>
<tr><td>Plantains</td><td>489</td></tr>
<tr><td>Plums and sloes</td><td>536</td></tr>
<tr><td>Raspberries</td><td>547</td></tr>
<tr><td>Sour cherries</td><td>530</td></tr>
<tr><td>Stone fruit, nes</td><td>541</td></tr>
<tr><td>Strawberries</td><td>544</td></tr>
<tr><td>Tangerines, mandarins, clem.</td><td>495</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Stimulants</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Coffee, green</td><td>656</td></tr>
<tr><td>Cocoa beans</td><td>661</td></tr>
<tr><td>Tea</td><td>667</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Spices</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Hops</td><td>677</td></tr>
<tr><td>Pepper (Piper spp.)</td><td>687</td></tr>
<tr><td>Chillies and peppers, dry</td><td>689</td></tr>
<tr><td>Vanilla</td><td>692</td></tr>
<tr><td>Nutmeg, mace and cardamoms</td><td>702</td></tr>
<tr><td>Anise, badian, fennel, corian.</td><td>711</td></tr>
<tr><td>Ginger</td><td>720</td></tr>
<tr><td>Spices, nes</td><td>723</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Fibre Crops</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Fibre Crops Nes</td><td>821</td></tr>
<tr><td>Flax fibre and tow</td><td>773</td></tr>
<tr><td>Jute</td><td>780</td></tr>
<tr><td>Other Bastfibres</td><td>782</td></tr>
<tr><td>Sisal</td><td>789</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="crop-box">
      <div class="card">
        <div class="card-header">
          <b>Other Crops</b>
        </div>
        <table class="table">
          <tbody>
<tr><td>Tobacco, unmanufactured</td><td>826</td></tr>
<tr><td>Natural rubber</td><td>836</td></tr>
<tr><td>Fodder crops</td><td>900</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <section class="py-5 text-center bg-primary mt-5">
    <div class="container">
      <RouterLink to="/map" class="map-btn">
        <div class="goto">
        view the map<br/><i class="fa-solid fa-caret-right"></i><i class="fa-solid fa-caret-right"></i>
        </div>
      </RouterLink>
    </div>
  </section>

  <div class="bottom-hide"></div>
  <div class="bottom-row bg-white">
    <span class="nut">Nutrient Navigator</span>
    <span class="opt">a product from</span>
    <a href="https://sciencebasedtargetsnetwork.org/"><img src="../assets/img/sbtn-logo-yellow.svg"/></a>
    <span class="opt">and</span>
    <a href="https://www.waterfootprint.org/"><img src="../assets/img/wfn-logo.png"/></a>
  </div>
</template>

<script>
import Masonry from "masonry-layout";

export default {
  name: "Crops",
  mounted() {
    this.masonry = new Masonry(this.$refs.masonryContainer, {
      itemSelector: ".crop-box",
      columnWidth: ".crop-box",
      gutter: 30
    });
  },
  beforeDestroy() {
    this.masonry.destroy();
  }
}
</script>

<style>
.crop-ctn {
  max-width: 1050px;
  margin: auto;
  .crop-box {
    width: 15rem;
    margin-bottom: 30px;
    border: 2px solid var(--bs-primary);
    border-radius:8px;
    padding: 1px;
    .card {
      .card-header {
        color: #fff;
        background-color: #7a0403;
      }
      .table {
        margin-bottom: 0;
        td:nth-child(1) {
          padding: 0.5rem 0.5rem 0.5rem 1rem;
          text-transform: lowercase;
        }
        td:nth-child(2) {
          padding: 0.5rem 1rem 0.5rem 0.5rem;
          text-align: right;
        }
      }
    }
  }
}
</style>
